import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export interface CreatePhoneRequest {
    phone: string,
    price: number,
    isoCountry: string,
    token?: string,
}


export const updateWabaDetails = async (domain: string, wabaId: string, phoneId: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `waba-details`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            domain,
            wabaId,
            phoneId
        },
        domain,
        isEncrypted: true,
    });
}